<template>
  <div class="ability-base-info">
    <el-card shadow="never">
      <h4 class="card-title">能力模型</h4>
      <el-row type="flex" justify="center">
        <el-col :sm="24" :md="24" :lg="22" :xl="20">
          <div class="model-chart" id="model-chart"></div>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="never" class="my-3">
      <div class="flex-between align-center">
        <h4 class="card-title">能力导图</h4>
        <el-button type="text" size="small" @click="toggleMask">{{
          showCanvasMask ? '进入移动模式' : '取消移动模式'
        }}</el-button>
      </div>
      <SimpleMindMap :mindData="mindData" v-if="mindData.data" :show-mask="showCanvasMask"></SimpleMindMap>
      <el-empty v-else description="暂无数据"></el-empty>
      <el-alert v-if="!showCanvasMask" center style="margin-bottom: 20px;" :show-icon="false" title="上下滚动：鼠标滚动  放大缩小：Ctrl+鼠标滑轮" type="info"> </el-alert>
      <target-detail :form="form" showTitleBg :showContent="false"></target-detail>
    </el-card>
  </div>
</template>
<script>
import TargetDetail from '@/components/ability/TargetDetail.vue'
import SimpleMindMap from '@/components/ability/SimpleMindMap.vue'
export default {
  name: 'AbilityBaseInfo',
  components: {
    TargetDetail,
    SimpleMindMap,
  },
  data() {
    return {
      modelData: [],
      form: {
        list: [],
      },
      showCanvasMask: true,
      mindData: {},
    }
  },
  mounted() {
    this.getCapabilityMap()
  },
  methods: {
    // 获取课程能力达成
    async getCapabilityMap() {
      await this.$store
        .dispatch('capability/getCapabilityMap', {
          course_id: this.$route.query.courseId,
        })
        .then((res) => {
          if (res.code === 1) {
            if (res.data.success) {
              let templist = [...res.data.configuration].map((item, index, self) => {
                return {
                  name: item.indicator_name,
                  value: self.length - index, // 金字塔会根据这个的值从小拍到大
                  indexValue: index + 1,
                  activity_counts: item.activity_counts,
                  knowledge_counts: item.knowledge_counts,
                  section_counts: item.section_counts,
                  description: item.description,
                  section: item.section,
                  level_id: item.level_id,
                }
              })
              this.modelData = templist
              this.form.list = res.data.configuration || []
              console.log('modelData:', this.modelData)
              this.initModelChart()
              this.initMindMap()
            } else {
              this.$confirm('尚未配置图谱', '提示', {
                confirmButtonText: '马上配置',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  this.$router.push({
                    name: 'abilityConfigure',
                    query: this.$route.query,
                  })
                })
                .catch(() => {})
            }
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    toggleMask() {
      this.showCanvasMask = !this.showCanvasMask
    },
    // 能力模型金字塔
    initModelChart() {
      var myChart = this.$echarts.init(document.getElementById('model-chart'))
      let colors = ['#F86262', '#FCC015', '#44CF9C', '#409EFF', '#e5934f', '#db646e']
      var option = {
        color: colors,
        tooltip: {
          show: true,
          formatter: (params) => {
            return params.name
          },
        },
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [
          {
            silent: true,
            type: 'funnel',
            top: '5%',
            left: '25%',
            width: '36%',
            height: '90%',
            label: {
              position: 'outside',
              rich: {
                a: {
                  color: '#343A40',
                  fontSize: 18,
                  fontWeight: 'bold',
                },
                b: {
                  color: '#98A6AD',
                  fontSize: 16,
                },
                x: {
                  color: '#6C757D',
                  fontSize: 16,
                },
              },
              formatter: function (params) {
                return `{a|${params.data.name}}      {b|主题：}{x|${params.data.section_counts}}     {b|评价项：}{x|${params.data.activity_counts}}`
              },
            },
            labelLine: {
              show: true,
              length: 80,
            },
            itemStyle: {
              borderWidth: 4,
              borderColor: '#fff',
            },
            sort: 'ascending',
            data: this.modelData,
          },
          {
            type: 'funnel',
            top: '5%',
            left: '25%',
            width: '36%',
            height: '90%',
            label: {
              position: 'inside',
              fontSize: 16,
              formatter: function (params) {
                return `L${params.data?.indexValue}`
              },
              color: '#ffffffA6',
            },
            itemStyle: {
              borderWidth: 4,
            },
            sort: 'ascending',
            data: this.modelData,
          },
        ],
      }
      myChart.setOption(option)
      window.onresize = () => {
        myChart.resize()
      }
    },
    // 初始化能力导图
    initMindMap() {
      console.log(this.$store.state.course.courseInfo)
      let mindData = {
        data: {
          id: this.$store.state.course.courseInfo.course_id,
          text: this.$store.state.course.courseInfo.fullname,
        },
        children: this.modelData.map((item) => {
          let children = item.section.map((sectionItem) => {
            return {
              data: {
                id: sectionItem.section_id,
                text: `<div style="text-align:center;padding-top: 10px">
                <div style="font-weight: bold;">${sectionItem.name}</div>
                <div style="color: #98A6AD;margin: 10px 0;">权重${sectionItem.weight}%</div>
                </div>
                `,
                richText: true,
              },
              children: sectionItem.activity.map((activityItem) => {
                return {
                  data: {
                    id: activityItem.id,
                    text: `<div style="text-align:center;padding-top: 10px;">
                      <div style="font-weight: bold;">${activityItem.name}</div>
                      <div style="color: #98A6AD;margin: 10px 0;">权重${activityItem.weight}%</div>
                      </div>
                    `,
                    richText: true,
                  },
                  children: [],
                }
              }),
            }
          })
          return {
            data: {
              id: item.level_id,
              text: `<div style="text-align:center;">
                <div style="font-weight: bold;">${item.name}</div>
                <div style="color: #98A6AD;margin: 10px 0;font-size: 14px;">${item.description}</div>
                </div>
                `,
              richText: true,
            },
            children,
          }
        }),
      }
      this.mindData = mindData
    },
  },
}
</script>
<style lang="scss" scoped>
.ability-base-info {
  .card-title {
    font-size: 18px;
    font-weight: bold;
  }
  .model-chart {
    height: 500px;
    width: 100%;
    margin-left: -60px;
  }
  .flex-left {
    flex: 1;
    position: relative;
    z-index: 2;
  }
  .flex-right {
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .legend-wrapper {
      position: relative;
      margin: 40px 0;
      padding: 10px 24px;
      display: flex;
      background-color: #f1f6f8;
      border-radius: 3px;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        right: 430px;
        transform: translateY(-50%);
        height: 2px;
        border-bottom: 1px dashed #e2e2e2;
      }
      &.line-1::before {
        width: 26vw;
      }
      &.line-2::before {
        width: 22vw;
      }
      &.line-3::before {
        width: 18vw;
      }
      &.line-4::before {
        width: 14vw;
      }
      .legend-item {
        color: #98a6ad;
        font-size: 14px;
        color: #98a6ad;
        line-height: 14px;
        min-width: 100px;
        .text-value {
          color: #6c757d;
          font-weight: bold;
        }
        &.value {
          position: relative;
          &::before,
          &::after {
            content: '';
            position: absolute;
            top: 2px;
            width: 1px;
            height: 12px;
            background-color: #e2e2e2;
          }
          &::before {
            left: -20px;
          }
          &::after {
            right: -20px;
          }
        }
      }
    }
  }
}
</style>
